export const FINGER_PRINT_PUBLIC_KEY_META = {
  /**OC-下载中心-下载 */
  DOWNLOAD_CENTER:
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCoeDJXvm8O6Q/Fs8kAxGq0MUvu0bt/OffTfF93cnUlJAlHFhWMIe3CMGB5G3NRY2VJbN3thDNyg1FpPodjkkkrdxxRzm8srwh/nfJVA6QAGjnAErnxlQPZzxWycDSNvAa79MrUJGQyDF4I06RT0qUxuUNdc9QQUi42Mbwqr4QQgwIDAQAB',
}

export const CAPTCHA_SCENE = {
  /**OC-下载中心-下载 */
  DOWNLOAD_CENTER: 'LgOcDcD',
}
/** 人机模型 - 登录 - publicKey */
export const LoginPublicKey = {
  os: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCBGF1YXa0qAm5rMTe599lCKfG5TXpuWLP3+PPRSvW9CqbDaLFwszXlidNGv4qsha1jwyt6vYUK4TiEln3P5I8yB38NbbmlAQXEcVdfuxnnhtjBBAxo4/SgiaACt+6sNJmMwTCfRUSsNVbOzzlKpiGKmeIT2WonfyfdNctm9wbnOwIDAQAB',
  ow: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC2s78gcgC5O/p1g6FjyoYn7vzMNY8TkpGw5Tqq0GkstL8gnFtg41uq/fWPD7S2YGAZw9jStA9T5tSitCQ6kMsk7XNhKi7WywF0EXW4+/0ta6R/9QUrwnUTv+c1n+nOnY/NgQVeNZgN0m1+/VHFBnf3Zjk2XKX1J2e3/qwWlK7/JwIDAQAB',
  oc: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCH4hsdh3SqX6JrvehQytnSKRl6AYKZajGVMqNPaCgoQQpJ8cGnSy5mnlMsuJboyOX6OU73SDG7q+Sc8UH5e6lwQyiSB/o/Z4dFWVj+ivwXIqR9g2bDmE+Jg4WawpOEqb33I1b1TyYhmSv4OA0qZVZ/iWO3mE5JU3Lsmwtxi8opXQIDAQAB',
  cpdc: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCYnAPvkTl2E1Rih999Wpr7YsqM8vUnmA9but56To4If2+pFx59BWHWieyTMwzUbsEDNs9oQhJSBa4Z3GIS4ZHrpudrFnIwhtQr/Oa+BgxBtywWABOFs9nomnliZSCJBN/226LSWML+04g0xuu1ircadYGtS00DgC5HPmZqU4Ud0wIDAQAB',
}
